import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
require('babel-polyfill');

Vue.use(Vuex)
Vue.prototype.$axios = axios

const store = new Vuex.Store({
    state: {
        hasSendContactForm: false,
        isSending: false
    },
    mutations: {
        setSendContactForm(state) {
            state.hasSendContactForm = true;
        },
        setIsSending(state, isSending){
            state.isSending = isSending
        }
    },
    actions: {
        sendConcatForm({commit}, payload) {
            commit("setIsSending", true);
            axios.post("https://xpera.ch/api/send", {
                email: payload.email,
                name: payload.name,
                message: payload.message
            })
                .then(() => {
                    commit("setIsSending", false);
                    commit("setSendContactForm");
                })
                .catch(() => {
                    commit("setIsSending", false);
                })
        }
    }
})

export default store;